export function formatMetersSquared(m: number | string): string {
  return `${m} m²`;
}
